const displayTypeOptions = [
  { name: 'Instant popup', value: 'instant_popup' },
  { name: 'FAB', value: 'fab' },
]

export { displayTypeOptions }
